import { Scale, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function BodyMetricsCard({ metricsData }) {
  if (!metricsData || (!metricsData.weight && !metricsData.body_fat && !metricsData.muscle_mass)) return null;
  return (
    <div className="bg-[#1B1B1B] border border-[#2A2A2E] rounded-lg p-4" data-testid="body-metrics-card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl text-white" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
          <Scale className="w-5 h-5 text-[#FF6B35] inline mr-1 mb-0.5" /> Mon corps
        </h2>
        <Link to="/profil" className="text-xs text-[#FF6B35] font-semibold">Details <ChevronRight className="w-3 h-3 inline" /></Link>
      </div>
      <div className="grid grid-cols-4 gap-2">
        {[
          { value: metricsData.weight, label: 'Poids (kg)', color: '#FF6B35' },
          { value: metricsData.body_fat, label: 'Gras (%)', color: '#FF00B8' },
          { value: metricsData.muscle_mass, label: 'Muscle (kg)', color: '#3b82f6' },
          { value: metricsData.metabolic_age, label: 'Age metab.', color: '#FFB800' },
        ].map(m => (
          <div key={m.label} className="bg-[#0F0F0F] rounded-lg p-2.5 text-center" style={{ borderTop: `2px solid ${m.color}` }}>
            <p className="font-mono text-xl font-bold text-white">{m.value ?? '—'}</p>
            <p className="text-[10px] text-[#AAAAAA] mt-0.5">{m.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
